import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { Pagination } from 'react-bootstrap';
import SearchableCustomerSelect from "../components/Common/SearchableCustomerSelect ";
import { getSubscriptionsAction } from '../../store/actions/Subscription/SubscriptionActions';
import { getPurchasePlansAction } from "../../store/actions/PurchasePlan/PurchasePlanActions";
import { getCustomersAction } from '../../store/actions/customer/CustomerActions';

const Subscription = () => {
	const dispatch = useDispatch();

	const { subscriptions } = useSelector((state) => state.subscription);
	const subscriptionRows = subscriptions?.rows || [];
	const { purchasePlan } = useSelector((state) => state.purchasePlan);
	const purchasePlanRows = purchasePlan?.rows || [];
	const totalPages = subscriptions?.pages || 1;

	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize] = useState(10);
	const [filterQuery, setFilterQuery] = useState('')

	const [showFilterPopup, setShowFilterPopup] = useState(false);
	const filterButtonRef = useRef(null);
	const filterPopupRef = useRef(null);

	const [filterValues, setFilterValues] = useState({
		plan: '',
		customer: ''
	});

	const buildFilterQuery = () => {
		const params = new URLSearchParams();

		if (filterValues.customer) {
			params.append('filter_userId', `${filterValues.customer}`);
		}

		if (filterValues.plan) {
			params.append('filter_subscriptionPlanId', `${filterValues.plan}`); // Assuming role is the ID like '681aea98f5a25f1b4495fb30'
		}

		return params.toString(); // Returns the full query string
	};

	const applyFilters = () => {
		const filterQuery = buildFilterQuery();
		setFilterQuery(filterQuery)
		setShowFilterPopup(false);
	};

	const resetFilters = () => {
		dispatch(getSubscriptionsAction(currentPage, pageSize, "", "populate=userId,subscriptionPlanId"));
		setFilterValues({ plan: '', customer: ''});
		setShowFilterPopup(false);
	};

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				filterPopupRef.current &&
				!filterPopupRef.current.contains(event.target) &&
				!filterButtonRef.current.contains(event.target)
			) {
			setShowFilterPopup(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	useEffect(() => {
		dispatch(getSubscriptionsAction(currentPage, pageSize, "", "populate=userId,subscriptionPlanId&"+filterQuery));
	}, [dispatch, currentPage, pageSize, filterQuery]);

	useEffect(() => {
		dispatch(getPurchasePlansAction(1, 100, "","filter_isActive=true"));
		dispatch(getCustomersAction());
	}, [dispatch]);

	return (
		<>
			<div className="col-12">
				<div className="card">
					<div className="card-header d-flex flex-wrap justify-content-between align-items-center gap-3">
						<h4 className="card-title mb-0">Subscription List</h4>

						{/* Filter Icon */}
						<div className="position-relative">
							<button
								className="btn btn-outline-secondary shadow btn-xs sharp me-2"
								onClick={() => setShowFilterPopup((prev) => !prev)}
								ref={filterButtonRef}
							>
								<i className="fa fa-filter"></i>
							</button>

							{/* Filter Popup */}
							{showFilterPopup && (
								<div
									className="card p-3 shadow position-absolute"
									style={{
										right: '0',   
										zIndex: 1000,
										width: '300px',
										height: '200px'
									}}
									ref={filterPopupRef}
								>
									{/* Filter Fields */}
									{/* <input
										type="text"
										className="form-control mb-2"
										placeholder="Name"
										value={filterValues.name}
										onChange={(e) => setFilterValues({ ...filterValues, name: e.target.value })}
									/> */}

									<select
										className="form-control mb-2"
										value={filterValues.plan}
										onChange={(e) => setFilterValues({ ...filterValues, plan: e.target.value })}
									>
										<option value="">All Plan</option>
										{purchasePlanRows.map((data) => (
											<option key={data._id} value={data._id}>{data.name}</option>
										))}
									</select>

                                    <SearchableCustomerSelect onSelect={(option) => setFilterValues({ ...filterValues, customer: option?.value })} />
									
									<div className="d-flex justify-content-between mt-4">
										<button className="btn btn-secondary" onClick={resetFilters}>Reset</button>
										<button className="btn btn-primary" onClick={applyFilters}>Apply</button>
									</div>
								</div>
							)}
						</div>
					</div>
					<div className="card-body">
						<div className="table-responsive">
							<table className="table table-striped">
								<thead>
									<tr>
										<th>Customer Name</th>
										<th>Plan</th>
										<th>Details</th>
										<th>Start</th>
										<th>End</th>
									</tr>
								</thead>
								<tbody>
									{subscriptionRows.map((data) => (
										<tr key={data._id}>
											<td>{data.userId.name}</td>
											<td>
												<div>Remaining Posts : {data.remainingPosts + "( " + data.subscriptionPlanId.maxListings + " )"}</div>
												<div>Remaining Featured : {data.remainingFeatured + "( " + data.subscriptionPlanId.maxFeaturedListings + " )"}</div>
											</td>
											<td>
												<p>{data.subscriptionPlanId.name}</p>
											</td>
											<td>
												{moment(data.startDate).format("DD/MM/YYYY, hh:mm A")}
											</td>
											<td>
												{moment(data.endDate).format("DD/MM/YYYY, hh:mm A")}
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>

						<div className="d-flex justify-content-between align-items-center mt-4">
							<div></div> {/* Empty div to align right side content */}
							<div className="d-flex align-items-center gap-3">
								<span className="text-muted">Total : {subscriptions?.total || subscriptionRows.length}</span>
								<Pagination className="pagination-gutter pagination-circle pagination mb-0">
									<Pagination.Prev
										disabled={currentPage === 1}
										onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
									/>
									{Array.from({ length: totalPages }, (_, i) => (
										<Pagination.Item
											key={i + 1}
											active={i + 1 === currentPage}
											onClick={() => setCurrentPage(i + 1)}
										>
											{i + 1}
										</Pagination.Item>
									))}
									<Pagination.Next
										disabled={currentPage === totalPages}
										onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
									/>
								</Pagination>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Subscription;
